module.exports = __webpack_public_path__ + "public/static/img/pp-logo-dark-theme.5bfab93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pp-logo-dark-theme.svg
// module id = AHID
// module chunks = 1